(function () {

    'use strict';

    if (typeof window === 'undefined') {

        module.exports = exportFn(
            require('../enums/dataSourceIds.js'),
            require('../../../enums/metrics.js'),
            require('../metricRequest.js'),
            require('../../../modules/data/channels.js'),
            require('../client/cacheLayer.js'),
            require('lodash')
        );

    } else {
        RivalIQ.module('metrics.new.client', function (metricsNew) {
            metricsNew.MetricConverter = exportFn(
                RivalIQ.metrics.new.enums.DataSourceIds,
                RivalIQ.enums,
                RivalIQ.metrics.new.MetricRequest,
                RivalIQ.data.channels,
                RivalIQ.metrics.new.client.CacheLayer,
                window._
            );
        });
    }

    function exportFn(DataSourceIds, enums, MetricRequest, channels, CacheLayer, _) {

        // NOTE if you use averageRate(), be sure to update services/metrics/dataSources/publicPostsDataSource.js getRateFields()
        const propertyMapping = {
            id: 'postId',
            postId: 'postId',
            count: 'distinctCount(postId)',
            posts_about: 'distinctCount(postId)',
            engagement_total: 'sum(engagement_total)',
            engagement_total_per_post: 'average(engagement_total)',
            presence_reach: 'sum(presence_reach)',
            with_hashtags: 'sum(has_hashtags)',
            avg_activity_per_period: 'averagePerCompanyPerPeriod(postId)',
            avg_engagement_rate_per_post_in_period: 'averageRate(engagement_rate_by_presence_reach)',
            avg_engagement_rate_per_post: 'averageRate(engagement_rate_by_presence_reach)',
            'companyId.count': 'distinctCount(companyId)',
            companies_using: 'distinctCount(companyId)',

            count_likely_boosted: 'distinctCount(postId)',
            count_non_boosted: 'distinctCount(postId)',
            engagement_total_likely_boosted: 'sum(engagement_total)',
            presence_reach_likely_boosted: 'sum(presence_reach)',
            engagement_total_non_boosted: 'sum(engagement_total)',
            presence_reach_non_boosted: 'sum(presence_reach)',

            avg_count_landscape: 'averagePerCompanyPerPeriod(postId)',
            avg_engagement_rate_per_post_day: 'averageRate(engagement_rate_by_presence_reach)',
            engagement_rate_by_presence_reach_lift: 'aggregateLift(engagement_rate_by_presence_reach_lift)',
            other_posts_engagement_rate_by_presence_reach: 'aggregateLift(other_posts_engagement_rate_by_presence_reach)',
            views: 'sum(video_views)',
            engagement_total_per_view: 'averageRate(engagement_rate_by_view)',
            impressions: 'sum(impressions)',
            estimated_impressions: 'sum(estimated_impressions)',
            engagement_rate_by_estimated_impression: 'averageRate(engagement_rate_by_estimated_impression)'
        };

        const dimensionMapping = (dimension) => {
            return {
                postDay: 'day',
                hour: 'hourOfDay',
                type: 'mediaType',
                post: 'postId',
                channel: 'source',
                post_tag_id: 'postTagId',
                engagement_type: 'engagementType',
                reaction_type: 'reactionType',
                hashtags: 'hashtag'
            }[dimension] || dimension;
        };

        const BaseMetricMappings = {
            engagement_rate_by_presence_reach: 'engagement_rate',
            engagement_rate_by_view: 'engagement_rate_by_view',
            engagement_rate_by_presence_reach_lift: 'engagement_rate_by_presence_reach_lift',
            engagement_total: 'engagement_total',
            message: ['message', 'display.message'],
            postLink: 'display.postLink',
            mediaType: ['type', 'display.type'],
            link: 'display.link',
            linkTitle: 'display.linkTitle',
            canonicalUrl: 'canonicalUrl',
            companyId: 'company_id',
            postId: 'id',
            published_at: 'published_at',
            captured_at: 'captured_at',
            platformImageUrl: ['display.video', 'platformImageUrl'],
            imageUrl: 'image',
            postedTitle: 'postedTitle',
            linkDescription: 'linkDescription',
            presence_handle: 'presence_handle',
            presence_reach: 'presence_reach',
            source: 'source',
            'native_id': 'native_id',
            'engagementType:engagement_total': 'engagement_type',
            'postTagId:postId': 'post_tag_ids',
            impressions: 'impressions',
            estimated_impressions: 'estimated_impressions',
            engagement_rate_by_estimated_impression: 'engagement_rate_by_estimated_impression'
        };

        const GroupByDimensionMapping = (oldMetric) => {
            if (oldMetric.keywordsOnly) {
                return 'keyword';
            }

            return {
                SOCIAL_POSTS_POST_TAG_IDS: 'post_tag_id',
                SOCIAL_POSTS_HASHTAGS: 'hashtag'
            }[oldMetric.key];
        };

        const CrossChannelMetricMappings = _.defaults({
            video_views: ['views', 'video_views'],
            reactions: 'reactions',
            'reactionType:engagement_total': 'reaction_type',
            post_video_views: 'post_views'
        }, BaseMetricMappings);

        const TwitterMetricMappings = _.defaults({
            tweetType: 'tweetType',
            sentiment: 'display.sentiment',
            video_views: 'video_views'
        }, BaseMetricMappings);

        const FacebookMetricMappings = _.defaults({
            promoted_likelyhood: 'promoted_likelyhood',
            reactions: 'reactions',
            'reactionType:engagement_total': 'reaction_type',
            video_views: ['views', 'video_views'],
            post_video_views: 'post_views'
        }, BaseMetricMappings);

        const InstagramMetricMappings = _.defaults({
            video_views: 'video_views'
        }, BaseMetricMappings);

        const YoutubeMetricMappings = _.defaults({
            video_views: ['views', 'video_views']
        }, BaseMetricMappings);

        const TikTokMetricMappings = _.defaults({
            video_views: ['views', 'video_views']
        }, BaseMetricMappings);

        const PostOrderByMappings = _.reduce(_.extend({},
            CrossChannelMetricMappings,
            TwitterMetricMappings,
            FacebookMetricMappings,
            InstagramMetricMappings,
            YoutubeMetricMappings,
            TikTokMetricMappings
        ), (memo, value, key) => {
            // invert the object. values that are arrays will be split up into two separate attributes. see #31741
            // ie {video_views: ['views', 'video_views']} => {views: 'video_views', 'video_views': 'video_views'}
            if (_.isArray(value)) {
                _.each(value, (val) => {
                    if (!memo[val]) {
                        memo[val] = key;
                    }
                });
            } else if (!memo[value]) {
                memo[value] = key;
            }

            return memo;
        }, {});
        _.extend(PostOrderByMappings, {
            likes: {
                dimensions: ['reactionType'],
                reactionType: 'likes',
                measure: 'sum(engagement_total)'
            }
        });

        function getMappingField(metricRequest) {
            const field = metricRequest.measure.field;
            switch (metricRequest.dataSourceId) {

                case RivalIQ.metrics.new.enums.DataSourceIds.CROSS_CHANNEL_PUBLIC_POST_DATA:
                    return CrossChannelMetricMappings[field];

                case RivalIQ.metrics.new.enums.DataSourceIds.TWITTER_PUBLIC_POST_DATA:
                    return TwitterMetricMappings[field];

                case RivalIQ.metrics.new.enums.DataSourceIds.FACEBOOK_PUBLIC_POST_DATA:
                    return FacebookMetricMappings[field];

                case RivalIQ.metrics.new.enums.DataSourceIds.INSTAGRAM_PUBLIC_POST_DATA:
                    return InstagramMetricMappings[field];

                case RivalIQ.metrics.new.enums.DataSourceIds.YOUTUBE_PUBLIC_POST_DATA:
                    return YoutubeMetricMappings[field];

                case RivalIQ.metrics.new.enums.DataSourceIds.TIKTOK_PUBLIC_POST_DATA:
                    return TikTokMetricMappings[field];

                default:
                    return '';
            }
        }

        function getSourceForOldMetric(oldMetric) {
            let source = oldMetric.source;
            if (_.isUndefined(source)) {
                source = RivalIQ.data.channels.get(oldMetric.channel).get('source');
            }

            if (_.isUndefined(source)) {
                source = enums.sources.CROSS_CHANNEL;
            }

            return source;
        }

        function getPostMetricMappings(oldMetric) {
            const source = getSourceForOldMetric(oldMetric);
            switch (source) {
                case enums.sources.CROSS_CHANNEL:
                    return CrossChannelMetricMappings;

                case enums.sources.TWITTER:
                    return TwitterMetricMappings;

                case enums.sources.FACEBOOK:
                    return FacebookMetricMappings;

                case enums.sources.INSTAGRAM:
                    return InstagramMetricMappings;

                case enums.sources.YOUTUBE:
                    return YoutubeMetricMappings;

                case enums.sources.TIKTOK:
                    return TikTokMetricMappings;

                default:
                    return {};
            }
        }

        function getDataSourceForSource(oldMetric) {
            const source = getSourceForOldMetric(oldMetric);
            switch (source) {
                case enums.sources.CROSS_CHANNEL:
                    return RivalIQ.metrics.new.enums.DataSourceIds.CROSS_CHANNEL_PUBLIC_POST_DATA;

                case enums.sources.TWITTER:
                    return RivalIQ.metrics.new.enums.DataSourceIds.TWITTER_PUBLIC_POST_DATA;

                case enums.sources.FACEBOOK:
                    return RivalIQ.metrics.new.enums.DataSourceIds.FACEBOOK_PUBLIC_POST_DATA;

                case enums.sources.INSTAGRAM:
                    return RivalIQ.metrics.new.enums.DataSourceIds.INSTAGRAM_PUBLIC_POST_DATA;

                case enums.sources.YOUTUBE:
                    return RivalIQ.metrics.new.enums.DataSourceIds.YOUTUBE_PUBLIC_POST_DATA;

                case enums.sources.TIKTOK:
                    return RivalIQ.metrics.new.enums.DataSourceIds.TIKTOK_PUBLIC_POST_DATA;

                default:
                    throw new Error(`Social Posts Metric Converter - unknown source ${source}`);
            }
        }

        function makeBaseNewMetricRequest(oldMetric) {
            const newMetric = {
                dataSourceId: getDataSourceForSource(oldMetric),
                filters: {
                    company: {
                        landscapeId: oldMetric.landscapeId,
                        companyFilter: oldMetric.companySetDescriptor,
                        focusCompanyId: oldMetric.focusCompanyId
                    },
                    timePeriod: {
                        startDate: oldMetric.startDate || oldMetric.timePeriod.mainPeriodStart,
                        endDate: oldMetric.endDate || oldMetric.timePeriod.mainPeriodEnd,
                        timezone: oldMetric.timezone
                    },
                    publicPost: {
                        postIds: oldMetric.postIds,
                        searchTerm: oldMetric.searchTerm || '',
                        canonicalUrlFilter: oldMetric.canonicalUrlFilter,
                        canonicalUrlExactMatch: oldMetric.canonicalUrlExactMatch,
                        primaryDomainFilter: oldMetric.primaryDomainFilter,
                        postTagConjunction: oldMetric.postTagConjunction,
                        postTagExclude: oldMetric.postTagExclude,
                        minDistinctCompanyIds: oldMetric.hashtagsMinCompanies,
                        minDistinctPostIds: oldMetric.hashtagsMinPosts,
                        excludePostsWithoutLinks: oldMetric.excludePostsWithoutLinks,
                        excludeNullPosts: oldMetric.excludeNullPosts
                    },
                    ordering: {
                        limit: oldMetric.limit
                    }
                }
            };

            if (oldMetric.postTagIds) {
                newMetric.filters.publicPost.postTagIds = oldMetric.postTagIds.toString().split(',').map(postTagId => Number(postTagId) || postTagId);
            }

            if (oldMetric.type) {
                newMetric.filters.publicPost.mediaTypes = [oldMetric.type];
            }

            if (oldMetric.tweetType) {
                newMetric.filters.publicPost ||= {};

                const tweetTypeIds = oldMetric.tweetType.toString().split(',');
                newMetric.filters.publicPost.tweetTypes = _.map(tweetTypeIds, tweetTypeId => _.find(enums.tweetTypes, {
                    id: Number(tweetTypeId)
                }).name);
            }

            if (oldMetric.mustHavePostTagIds) {
                newMetric.filters.publicPost.mustHavePostTagIds = _.map(oldMetric.mustHavePostTagIds.toString().split(','), postTagId => Number(postTagId) || postTagId);
            }

            if (oldMetric.companyIds) {
                if (_.isString(oldMetric.companyIds)) {
                    newMetric.filters.company.onlyCompanyIds = _.map(oldMetric.companyIds.split(','), companyId => Number(companyId));
                } else if (_.isArray(oldMetric.companyIds)) {
                    newMetric.filters.company.onlyCompanyIds = oldMetric.companyIds;
                } else {
                    newMetric.filters.company.onlyCompanyIds = [oldMetric.companyIds];
                }
            }

            if (_.includes([DataSourceIds.CROSS_CHANNEL_PUBLIC_POST_DATA, DataSourceIds.TWITTER_PUBLIC_POST_DATA], newMetric.dataSourceId)) {
                const tweetTypes = _.get(newMetric, ['filters', 'publicPost', 'tweetTypes']);
                if (_.isEmpty(tweetTypes)) {
                    newMetric.filters.publicPost.tweetTypes = ['normal'];
                }
            }

            if (oldMetric.orderBy && oldMetric.orderBy.property) {
                let orderByProperties = [oldMetric.orderBy.property];
                if (oldMetric.keywordsOnly) {
                    if (oldMetric.orderBy.property === 'companies_using') {
                        orderByProperties = ['companies_using', 'count', 'engagement_total_per_post'];
                    } else {
                        orderByProperties = [oldMetric.orderBy.property, 'engagement_total_per_post'];
                    }
                }

                newMetric.filters.ordering.sort = _(orderByProperties)
                    .map((orderByProperty, idx) => {
                        const mapping = (_.includes(oldMetric.dimensions, 'post') ? PostOrderByMappings[orderByProperty] : propertyMapping[orderByProperty]);
                        if (mapping) {

                            const sort = {
                                sortOrder: (oldMetric.sortOrder === -1 ? 'asc' : 'desc')
                            };

                            if (oldMetric.keywordsOnly && idx > 0) {
                                sort.sortOrder = 'desc';
                            }

                            if (_.isString(mapping)) {
                                sort.measure = mapping;
                            } else {
                                _.extend(sort, mapping);
                            }

                            if (oldMetric.orderBy.engagement_type) {
                                sort.engagementType = oldMetric.orderBy.engagement_type;
                            }

                            return sort;
                        }
                    })
                    .compact()
                    .value();
            }

            if (oldMetric.isSummaryRowData || !_.isEqual(oldMetric.dimensions, ['companyId'])) {
                newMetric.filters.publicPost.elideZeroPostsCompanies = true;
            }

            switch (oldMetric.promotedPosts) {
                case enums.likelyPromoted.filterTypes.exclude:
                    newMetric.filters.publicPost.promotedPosts = [enums.likelyPromoted.values.notLikelyPromoted];
                    break;

                case enums.likelyPromoted.filterTypes.only:
                    newMetric.filters.publicPost.promotedPosts = [enums.likelyPromoted.values.likelyPromoted];
                    break;

                case enums.likelyPromoted.filterTypes.include:
                default:
                    newMetric.filters.publicPost.promotedPosts = [enums.likelyPromoted.values.likelyPromoted, enums.likelyPromoted.values.notLikelyPromoted];
            }

            if (_.includes(['count_likely_boosted', 'engagement_total_likely_boosted', 'presence_reach_likely_boosted'], oldMetric.property)) {
                newMetric.filters.publicPost.promotedPosts = _.without(newMetric.filters.publicPost.promotedPosts, enums.likelyPromoted.values.notLikelyPromoted);
            } else if (_.includes(['count_non_boosted', 'engagement_total_non_boosted', 'presence_reach_non_boosted'], oldMetric.property)) {
                newMetric.filters.publicPost.promotedPosts = _.without(newMetric.filters.publicPost.promotedPosts, enums.likelyPromoted.values.likelyPromoted);
            }

            if (oldMetric.keywordsOnly) {
                newMetric.filters.publicPost.minDistinctCompanyIds = oldMetric.keywordsMinCompanies || 1;
                newMetric.filters.publicPost.minDistinctPostIds = oldMetric.keywordsMinPosts ?? 3;

                if (oldMetric.isSummaryRowData) {
                    newMetric.dimensionReductions = [{
                        keyword: 'sum'
                    }];
                }
            }

            return newMetric;
        }

        function oldMetricImpliedDimensions(oldMetric) {
            let dimensions = oldMetric.dimensions || [];

            if (_.includes(oldMetric.property, 'companyId.count')) {
                dimensions = _.union(dimensions, ['companyId']);
            }

            if (oldMetric.companyId) {
                dimensions = _.union(dimensions, ['companyId']);
            }

            // With the way the LTR expression stuff works in the old metric stack, it's important that companyId
            // comes early. Otherwise, we risk getting a companyId.count value that just counts for companies that
            // have that particular dimension instead of all companies in the landscape. See #31271
            if (_.includes(dimensions, 'companyId') && _.includes(['SOCIAL_POST', 'SOCIAL_POSTS'], oldMetric.key) && !_.includes(dimensions, 'keyword')) {
                dimensions = ['companyId'].concat(_.without(dimensions, 'companyId'));
            }

            if (_.includes(dimensions, 'hashtag')) {
                dimensions = _.without(dimensions, 'post');
            }

            return dimensions;
        }

        const convertToNewMetricRequest = function (oldMetric) {
            let dimensions = oldMetricImpliedDimensions(oldMetric);
            dimensions = _.uniq(_.map(dimensions, dimensionMapping));

            const newMetric = makeBaseNewMetricRequest(oldMetric);
            newMetric.dimensions = dimensions;
            newMetric.measure = propertyMapping[oldMetric.property] || 'distinctCount(postId)';

            return newMetric;
        };

        function getBucketForResultRow(oldMetric, results, resultDimensions, row) {

            const leafBucket = _.reduce(resultDimensions, (leafBucket, dimension, idx) => {

                let dimensionValue = row[idx];

                if (_.includes(['day', 'week', 'month'], dimension)) {
                    const firstPeriodStartDate = moment.utc(oldMetric.timePeriod.mainPeriodStart).startOf(dimension);
                    dimensionValue = moment.utc(dimensionValue).diff(firstPeriodStartDate, dimension);
                }

                leafBucket.dimensions ||= {};
                leafBucket.dimensions[dimension] ||= {};
                leafBucket.dimensions[dimension].buckets ||= {};
                leafBucket.dimensions[dimension].buckets[dimensionValue] ||= {};
                leafBucket = leafBucket.dimensions[dimension].buckets[dimensionValue];

                return leafBucket;
            }, results);

            return leafBucket;
        }

        function convertToSPDataForm(oldMetrics, newMetricResults) {
            const results = {};

            _.each(oldMetrics, (oldMetric, idx) => {
                // Important to use oldMetric.dimensions here, as it's the mix of free and fixed dimensions that
                // the extraction code expects to be present.
                let oldFormatDimensions = oldMetricImpliedDimensions(oldMetric);

                let newResults = newMetricResults[idx];

                if (oldMetric.isSummaryRowData) {
                    oldFormatDimensions = _.union([GroupByDimensionMapping(oldMetric)], oldFormatDimensions);
                    newResults = {
                        dimensions: _.union([dimensionMapping(GroupByDimensionMapping(oldMetric))], newResults.dimensions),
                        data: _.map(newResults.data, row => {
                            return ['__SUMMARY_ROW__'].concat(row);
                        })
                    };
                }

                let property = oldMetric.property;
                if (property === 'count / period' || property === 'companyId.count') {
                    property = 'count';
                }

                if (!_.isEmpty(newResults.dimensions)) {

                    let data = newResults.data;
                    if (_.includes(oldFormatDimensions, 'channel')) {
                        const channelDimensionIdx = _.findIndex(oldFormatDimensions, dimension => dimension === 'channel');
                        data = _.map(data, row => {
                            row = _.clone(row);
                            row[channelDimensionIdx] = channels.get(row[channelDimensionIdx]).get('channel');
                            return row;
                        });
                    }

                    _.each(data, row => {
                        const leafBucket = getBucketForResultRow(oldMetric, results, oldFormatDimensions, row);
                        const value = (property === 'keyword' ? _.first(row) : _.last(row));
                        leafBucket[property] = value;

                        // The keywords tooltip uses posts_about when it means count.
                        if (property === 'count') {
                            leafBucket.posts_about = value;
                        }
                    });
                } else {
                    const value = _.last(_.get(newResults.data, [0]));
                    if (_.isEmpty(oldFormatDimensions)) {
                        results[property] = value;
                    } else {
                        const dimensionValues = _.map(oldFormatDimensions, dimension => oldMetric[dimension]);
                        const leafBucket = getBucketForResultRow(oldMetric, results, oldFormatDimensions, dimensionValues);
                        leafBucket[property] = value;
                    }
                }
            });

            return results;
        }

        function expandOldMetrics(oldMetric) {
            let additionalOldMetrics = [
                _.defaults({
                    property: 'count',
                    dimensions: []
                }, oldMetric),
                _.defaults({
                    property: 'count',
                    dimensions: ['companyId']
                }, oldMetric)
            ];

            let oldMetrics = [];
            if (!oldMetric.property.endsWith('period') && oldMetric.property.indexOf('/') !== -1) {
                _.each(oldMetric.property.split('/'), property => {
                    oldMetrics.push(_.extend({}, oldMetric, {
                        property: property.trim()
                    }));
                });
            } else {
                oldMetrics.push(oldMetric);
            }

            if (oldMetric.over) {
                _.each(oldMetrics, om => {
                    oldMetrics.push(_.extend({}, om, oldMetric.over, {
                        dimensions: _.union([], om.dimensions, oldMetric.over.dimensions)
                    }));
                });
            }

            if (GroupByDimensionMapping(oldMetric)) {

                // The companies using cell view does some funky stuff to make tooltip, we need to request the metrics that it's going to use.
                additionalOldMetrics = [
                    _.defaults({
                        property: 'count',
                        dimensions: [GroupByDimensionMapping(oldMetric), 'companyId']
                    }, oldMetric),
                    _.defaults({
                        property: 'engagement_total',
                        dimensions: [GroupByDimensionMapping(oldMetric), 'companyId']
                    }, oldMetric),
                    _.defaults({
                        property: 'presence_reach',
                        dimensions: [GroupByDimensionMapping(oldMetric), 'companyId']
                    }, oldMetric)
                ];

                if (oldMetric.includeSummaryRow &&
                    GroupByDimensionMapping(oldMetric)) {

                    const oldSummaryMetrics = _.map(oldMetrics.concat(additionalOldMetrics), summaryOldMetric => {
                        if (summaryOldMetric.property === 'engagement_rate_by_presence_reach_lift' ||
                            summaryOldMetric.property === 'postId') {
                            return;
                        }
                        const summaryRowMetric = _.defaults({
                            dimensions: _.without(summaryOldMetric.dimensions, GroupByDimensionMapping(summaryOldMetric)),
                            isSummaryRowData: true
                        }, summaryOldMetric);
                        delete summaryRowMetric.orderBy;

                        return summaryRowMetric;
                    });

                    oldMetrics = oldMetrics.concat(_.compact(oldSummaryMetrics));
                }
            }

            if (oldMetric.keywordsOnly) {
                additionalOldMetrics.push(_.defaults({
                    property: 'count',
                    dimensions: ['keyword', 'companyId']
                }, oldMetric));
            }

            return oldMetrics.concat(additionalOldMetrics);
        }

        const fetchPostAggregates = function (socialPostsModel, attrs) {
            const oldMetrics = expandOldMetrics(attrs);
            const newMetrics = _.map(oldMetrics, oldMetric => convertToNewMetricRequest(oldMetric));

            const deferred = new $.Deferred();

            CacheLayer.fetch(newMetrics).then(function (newMetricResults) {
                const error = _.get(newMetricResults, [0, 'error']);
                if (error) {
                    const spErrorObject = _.defaults({
                        errorName: error.name,
                        errorMessage: error.message
                    }, error);
                    deferred.reject(spErrorObject);
                } else {
                    const data = convertToSPDataForm(oldMetrics, newMetricResults);
                    deferred.resolve(data);
                }
            });

            return deferred;
        };

        const fetchPosts = function (socialPostsModel, attrs) {
            // The old school keyword metric is in the singular Social Post metric, but we'd expect it to be in the Social Posts aggregate metric.
            if (_.includes(attrs.dimensions, 'keyword')) {
                return fetchPostAggregates(socialPostsModel, attrs);
            }

            const baseNewMetricRequest = makeBaseNewMetricRequest(attrs);

            const oldStaticMetricRequests = [_.defaults({
                dimensions: [],
                property: 'count'
            }, attrs), _.defaults({
                dimensions: [],
                property: 'count',
                companyId: null
            }, attrs)];

            const newStaticMetrics = _.map(oldStaticMetricRequests, oldMetric => convertToNewMetricRequest(oldMetric));

            let newMetrics = [];
            if (attrs.property === 'post' || _.includes(attrs.dimensions, 'post')) {
                newMetrics = _.map(getPostMetricMappings(attrs), (oldMetricDest, newMetric) => {
                    if (_.isString(newMetric)) {
                        if (newMetric.indexOf(':') !== -1) {
                            const [dimension, measure] = newMetric.split(':');
                            newMetric = {
                                dimensions: [dimension],
                                measure: measure
                            };
                        } else {
                            newMetric = {
                                measure: newMetric
                            };
                        }
                    }

                    const dimensions = _.union(['postId'], newMetric.dimensions);

                    return MetricRequest.canonicalizeMetricRequest(_.defaults({
                        dimensions: dimensions,
                        measure: newMetric.measure
                    }, baseNewMetricRequest));
                });
            }

            const deferred = new $.Deferred();

            CacheLayer.fetch(newStaticMetrics.concat(newMetrics)).then(function (newMetricResults) {

                const error = _.get(newMetricResults, [0, 'error']);
                if (error) {
                    const spErrorObject = _.defaults({
                        errorName: error.name,
                        errorMessage: error.message
                    }, error);
                    return deferred.reject(spErrorObject);
                }
                const data = convertToSPDataForm(oldStaticMetricRequests, newMetricResults);

                const postResults = _.takeRight(newMetricResults, newMetricResults.length - newStaticMetrics.length);
                _.set(data, ['dimensions', 'post', 'buckets'], {});
                _.each(postResults, (postResult, metricIdx) => {
                    const metricRequest = newMetrics[metricIdx];

                    _.each(postResult.data, resultForPost => {
                        const postIdx = resultForPost[0];
                        const value = _.last(resultForPost);
                        data.dimensions.post.buckets[postIdx] ||= {};

                        const extraDimension = _.first(_.without(metricRequest.dimensions, 'postId'));
                        if (extraDimension === 'engagementType') {
                            const engagementType = resultForPost[1];
                            _.set(data.dimensions.post.buckets[postIdx], ['dimensions', 'engagement_type', 'buckets', engagementType, 'engagement_total'], value);
                            return;
                        }

                        if (extraDimension === 'reactionType') {
                            const reactionType = resultForPost[1];
                            _.set(data.dimensions.post.buckets[postIdx], ['dimensions', 'reaction_type', 'buckets', reactionType, 'engagement_total'], value);
                            _.set(data.dimensions.post.buckets[postIdx], [reactionType], value);
                            return;
                        }

                        if (extraDimension === 'postTagId') {
                            const postTagId = resultForPost[1];
                            const postTagIds = _.get(data.dimensions.post.buckets[postIdx], ['post_tag_ids'], []);
                            _.set(data.dimensions.post.buckets[postIdx], ['post_tag_ids'], _.union(postTagIds, [postTagId]));
                            return;
                        }

                        let resultField = getMappingField(metricRequest);
                        if (!_.isArray(resultField)) {
                            resultField = [resultField];
                        }

                        _.each(resultField, dest => {
                            _.set(data.dimensions.post.buckets[postIdx], dest, value);
                        });
                    });
                });

                if (!_.isEmpty(postResults)) {
                    const postIdMetric = _.findIndex(newMetrics, nm => nm.measure.field === 'postId');

                    _.each(postResults[postIdMetric].data, ([postId]) => {
                        const hasThumbnailUrl = !_.isEmpty(_.get(data.dimensions.post.buckets[postId], ['image']));
                        _.set(data.dimensions.post.buckets[postId], ['useThumbnailUrl'], hasThumbnailUrl);
                    });
                }

                deferred.resolve(data);
            });

            return deferred;
        };

        return {
            fetchPosts,
            fetchPostAggregates,
            convertToNewMetricRequest
        };
    }
})();
